import { MiddlewareArray } from '@reduxjs/toolkit'
import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/src/getDefaultMiddleware'
import { combineReducers, Reducer, ReducersMapObject } from 'redux'

import appSlice from 'src/core/store/appSlice'
import { logoApi } from 'src/core/store/service/logo'
import { referenceCountriesApi } from 'src/core/store/service/referenceCountries'
import { referenceCountriesCodeApi } from 'src/core/store/service/referenceCountriesCode'
import { referenceLanguagesApi } from 'src/core/store/service/referenceLanguages'
import { referenceLocalesApi } from 'src/core/store/service/referenceLocales'
import { referenceMarketsApi } from 'src/core/store/service/referenceMarkets'
import { referenceOrganizationsApi } from 'src/core/store/service/referenceOrganizations'
import { simulationApi } from 'src/core/store/service/simulation'
import { pageApi } from 'src/core/store/service/sitebuilder/pageApi'
import { roleApi } from 'src/core/store/service/sitebuilder/roleApi'
import storageApi from 'src/core/store/service/sitebuilder/storageApi'
import { userApi } from 'src/core/store/service/sitebuilder/userApi'
import { widgetApi } from 'src/core/store/service/sitebuilder/widgetApi'
import { TMiddleware } from 'src/core/store/state'

export const rootReducer = (appsStores: ReducersMapObject): Reducer => {
  return combineReducers({
    [pageApi.reducerPath]: pageApi.reducer,
    [widgetApi.reducerPath]: widgetApi.reducer,
    [roleApi.reducerPath]: roleApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [storageApi.reducerPath]: storageApi.reducer,
    [logoApi.reducerPath]: logoApi.reducer,
    [simulationApi.reducerPath]: simulationApi.reducer,
    [referenceOrganizationsApi.reducerPath]: referenceOrganizationsApi.reducer,
    [referenceMarketsApi.reducerPath]: referenceMarketsApi.reducer,
    [referenceLocalesApi.reducerPath]: referenceLocalesApi.reducer,
    [referenceLanguagesApi.reducerPath]: referenceLanguagesApi.reducer,
    [referenceCountriesApi.reducerPath]: referenceCountriesApi.reducer,
    [referenceCountriesCodeApi.reducerPath]: referenceCountriesCodeApi.reducer,
    app: appSlice,
    ...appsStores,
  })
}

export const getMiddleware = (
  customMiddleware: TMiddleware | undefined,
  loadedMiddlewares: MiddlewareArray<any> = new MiddlewareArray()
) => {
  return (getDefaultMiddleware: CurriedGetDefaultMiddleware) => {
    const coreReducers = [
      pageApi.middleware,
      widgetApi.middleware,
      roleApi.middleware,
      userApi.middleware,
      storageApi.middleware,
      logoApi.middleware,
      simulationApi.middleware,
      simulationApi.middleware,
      referenceOrganizationsApi.middleware,
      referenceMarketsApi.middleware,
      referenceLocalesApi.middleware,
      referenceLanguagesApi.middleware,
      referenceCountriesApi.middleware,
      referenceCountriesCodeApi.middleware,
    ]
    if (customMiddleware) {
      return customMiddleware(getDefaultMiddleware).concat(coreReducers).concat(loadedMiddlewares)
    }
    return getDefaultMiddleware().concat(coreReducers).concat(loadedMiddlewares)
  }
}
